export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6339.896ffa5a.jpg";